import { Box, Flex, FlexProps, TextInput, TextInputProps } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

type FilterHeaderProps = {
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  showFilters?: boolean;
  filterLabel?: string;
  inputProps?: TextInputProps;
  placeholder?: string;
};

export function FilterHeader({
  searchTerm,
  setSearchTerm,
  inputProps,
  placeholder = 'Search',
  ...props
}: FilterHeaderProps & FlexProps) {
  return (
    <Flex gap="xs" {...props}>
      <TextInput
        placeholder={placeholder}
        leftSection={<IconSearch size={16} />}
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        variant="compact"
        styles={{
          input: {
            height: 40,
          },
        }}
        flex={1}
        maw={320}
        w={320}
        {...inputProps}
      />
    </Flex>
  );
}

type SearchHeaderProps = {
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  showFilters?: boolean;
  filterLabel?: string;
  inputProps?: TextInputProps;
};

export function SearchHeader({ searchTerm, setSearchTerm, inputProps }: SearchHeaderProps) {
  return (
    <Box px="lg" py="xs" style={{ width: '100%' }}>
      <TextInput
        placeholder="Search by name or email address"
        leftSection={<IconSearch size={16} />}
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        variant="compact"
        styles={{
          input: {
            height: 40,
          },
        }}
        w="100%"
        {...inputProps}
      />
    </Box>
  );
}
